import { environment } from '@env/environment';
import { minutesToMilliseconds } from 'date-fns';

/** DOM events treated as user activity. `mousemove` is intentionally excluded — it is too noisy. */
export const SESSION_CHECK_ACTIVITY_EVENTS = ['mousedown', 'keydown', 'wheel', 'touchstart'] as const;

/** Minimum interval between two activity records; keeps state writes and timer resets cheap. */
export const SESSION_CHECK_ACTIVITY_THROTTLE_MS = 15_000;

/** How long before the session deadline the warning modal opens (the countdown duration). */
export const SESSION_CHECK_WARNING_MS = 60_000;

/** BroadcastChannel name used to share session events across tabs. */
export const SESSION_CHECK_BROADCAST_CHANNEL = 'session-check-activity';

/** Cross-tab message: user activity was recorded in the sending tab. */
export const SESSION_CHECK_ACTIVITY_MESSAGE = 'activity';

/** Cross-tab message: the sending tab has an authenticated session (log-in or page load). */
export const SESSION_CHECK_LOGGED_IN_MESSAGE = 'logged-in';

/** Cross-tab message: the user explicitly logged out in the sending tab. */
export const SESSION_CHECK_LOGGED_OUT_MESSAGE = 'logged-out';

/** Wall-clock moment (ms) at which a session with the given last activity expires. */
export const sessionCheckDeadlineAt = (lastActivityAt: number): number =>
  lastActivityAt + minutesToMilliseconds(environment.sessionTimer);
